import { Box, Button, Grid, ListItemText, Typography } from "@mui/material"
import { t } from "i18next"
import React, { useContext } from "react"
import DefaultButton from "../Button"
import { CircleIcon } from "../icons/CircleIcon"
import CloseSidebarButton from "../navigation/CloseSidebarButton"
import { SidebarProps2 } from "./Sidebar.interfaces"
import { StyledStickyButtonBox, StyledListItemHeaderGrid, StyledListWrapper, StyledSidebarDrawer } from "./Sidebar.styled"
import { AppContext } from "../AppContextProvider"
import theme from "css/theme/light"

export const SidebarNoForm = ({
    formData,
    formResult,
    children,
    flexDirection,
    childrenWrapperSx
}: SidebarProps2) => {
    const appContext = useContext(AppContext)
    const isSidebarOpen = appContext.isSidebarOpen === formData?.formId || appContext.isSidebarOpen === "Default"

    const toggleSidebar = () => {
        if (appContext.isSidebarOpen === "Default") {
            appContext.toggleSideBar("Default")
        } else {
            appContext.toggleSideBar(formData?.formId)
        }
    }

    return (
        <React.Fragment key="right">
            <StyledSidebarDrawer variant="persistent" anchor="right" open={isSidebarOpen}>
                <StyledListWrapper>
                    <CloseSidebarButton
                        toggleMenu={() => {
                            toggleSidebar()
                        }}
                    />

                    <Grid container pb={5} px={{ xs: 3, sm: 4 }} mt={0} pt={12}>
                        <StyledListItemHeaderGrid flexDirection={flexDirection} xs={12} md={12} pb={3}>
                            <CircleIcon
                                icon={formData?.icon}
                                backgroundColor={(theme.palette as any).primary[300]}
                                color={(theme.palette as any).primary[800]}
                                size="lg"
                                sx={{ marginRight: "14px" }}
                            />
                            <ListItemText
                                primary={
                                    <Typography color="textPrimary" variant="h2">
                                        {formData?.titleNew}
                                    </Typography>
                                }
                                secondary={
                                    <Typography color="textSecondary" variant="bodySmall">
                                        {formData?.subTitleNew}
                                    </Typography>
                                }
                            />
                        </StyledListItemHeaderGrid>
                    </Grid>
                    <Box px={{ xs: 3, sm: 4 }}
                        sx={{
                            flexGrow: 1,
                            overflowY: "auto",
                            minHeight: 0,
                            ...childrenWrapperSx,
                        }}>
                        {children}
                    </Box>
                    {formResult && <StyledStickyButtonBox p={{ xs: 3, sm: 4 }}>
                        <DefaultButton sx={{ width: "100%" }} result={formResult}>
                            {formData?.submitText}
                        </DefaultButton>
                        <Button
                            variant={"outlined"}
                            onClick={() => {
                                toggleSidebar()
                            }}
                        >
                            {t("global.buttons.cancel")}
                        </Button>
                    </StyledStickyButtonBox>}
                </StyledListWrapper>
            </StyledSidebarDrawer>
        </React.Fragment>
    )
}